export default __webpack_public_path__ + "static/media/Longspire.4198271a.jpg";